import React from 'react';

export default class CustomPaymentOption extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            textValue: this.format(this.props.textValue, this.props.format)
        };
    }
    format(value, format) {
        if (format === 'currency') {
            this.setIntl();
            let currencyFormat = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 2
            });
            return currencyFormat.format(value);
        }
        return value;
    }
    setIntl() {
        if (!global.Intl) {
            global.Intl = require('intl');
            require('intl/locale-data/jsonp/en.js');
        }
    }
    render() {
        return (
            <div ref={this.props.customRef} className="custom-payment-option">
                <label for={this.props.customRef}>{this.props.label}</label>
                <span className="main" style={{ margin: '0px' }}>
                    {this.state.textValue}
                </span>
                <span className="footer">{this.props.footer}</span>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/common/components/CustomPaymentOption.jsx